<template>
  <OrderPackingDetail label="Reimbursement" type="reimbursement" movement-type="main" :index-path="{ name: 'gudang.reimbursement.index' }" pengemasan-path="gudang.reimbursement.pengemasan" />
</template>

<script>
import OrderPackingDetail from '../../../../../components/order/OrderPackingDetail.vue';

export default {
  components: { OrderPackingDetail }
}
</script>